import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editHashtag = async ({
	uuid,
	payload
}: {
	uuid: string;
	payload: FormData;
}) => {
	const response = await cmsClient.patch<IAdminHashtag>(
		`/homepage/admin/hashtags/${uuid}/`,
		payload
	);

	return response.data;
};

const useEditHashtag = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Hashtag updated successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-hashtags"]);
		queryClient.invalidateQueries(["favourite-feeds"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(editHashtag, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useEditHashtag;
